/*
    path: used by routing to change routes path
    Component: React component that will be rendered for the associated path
    drawerName: Default is "", that will not generate a route on the drawer, if supplied any other value
    will add a routing to the Drawer element.
 */

export const routesTemplate = (path, Component, drawerName = '') => {
    return {
        path: path,
        component: Component,
        drawerName: drawerName
    }
};